import React, { useState } from 'react';
import { Heart, ArrowLeft } from 'lucide-react';
import { API } from '../App';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const text = await res.text();
      const data = JSON.parse(text);
      if (!res.ok) throw new Error(data.detail || 'Fehler');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" data-testid="forgot-password-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon">
            <Heart size={26} color="#fff" fill="#fff" />
          </div>
          <h3>Passwort vergessen</h3>
          <p>{sent ? 'E-Mail gesendet' : 'Geben Sie Ihre E-Mail-Adresse ein'}</p>
        </div>
        <div className="login-body">
          {sent ? (
            <div>
              <div style={{ background: '#D1FAE5', color: '#065F46', padding: '0.75rem 1rem', borderRadius: 10, marginBottom: '1rem', fontSize: 13, fontWeight: 500 }} data-testid="forgot-success">
                Wenn die E-Mail-Adresse in unserem System existiert, haben wir Ihnen einen Link zum Zurücksetzen gesendet. Bitte prüfen Sie auch Ihren Spam-Ordner.
              </div>
              <a href="/login" className="btn btn-primary btn-lg" style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }} data-testid="forgot-back-login">
                <ArrowLeft size={16} /> Zurück zum Login
              </a>
            </div>
          ) : (
            <>
              {error && (
                <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '0.75rem 1rem', borderRadius: 10, marginBottom: '1rem', fontSize: 13, fontWeight: 500 }} data-testid="forgot-error">{error}</div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>E-Mail-Adresse</label>
                  <input className="form-input" type="email" placeholder="ihre@email.de" value={email} onChange={e => setEmail(e.target.value)} required data-testid="forgot-email-input" />
                </div>
                <button className="btn btn-primary btn-lg" type="submit" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? 'Sende...' : 'Link anfordern'}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <a href="/login" style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }} data-testid="forgot-login-link">
                  <ArrowLeft size={12} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  Zurück zum Login
                </a>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="login-footer-text">BGPR Verwaltung &copy; 2026</div>
    </div>
  );
}
